const ACTIVE_CLASS = 'active'

const getTabParts = (root) => ({
    buttons: Array.from(root.querySelectorAll('[data-tab-button]')),
    panels: Array.from(root.querySelectorAll('[data-tab-content]')),
    images: Array.from(root.querySelectorAll('.data-tab-image')),
    bgImages: Array.from(root.querySelectorAll('.data-tab-bg-image'))
})

const setActiveClass = (items, activeIndex, { hideInactive = true } = {}) => {
    items.forEach((item, index) => {
        const isActive = index === activeIndex

        item.classList.toggle(ACTIVE_CLASS, isActive)
        item.setAttribute('aria-hidden', String(!isActive))

        if (hideInactive) {
            item.toggleAttribute('hidden', !isActive)
        }
    })
}

const activateTab = (root, activeIndex, focusButton = false) => {
    const { buttons, panels, images, bgImages } = getTabParts(root)

    buttons.forEach((button, index) => {
        const isActive = index === activeIndex

        button.classList.toggle(ACTIVE_CLASS, isActive)
        button.setAttribute('aria-selected', String(isActive))
        button.setAttribute('tabindex', isActive ? '0' : '-1')

        if (isActive && focusButton) {
            button.focus()
        }
    })

    setActiveClass(panels, activeIndex)
    setActiveClass(images, activeIndex, { hideInactive: false })
    setActiveClass(bgImages, activeIndex, { hideInactive: false })
}

const getNextIndex = (event, currentIndex, total) => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        return (currentIndex + 1) % total
    }

    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        return (currentIndex - 1 + total) % total
    }

    if (event.key === 'Home') {
        return 0
    }

    if (event.key === 'End') {
        return total - 1
    }

    return null
}

export const initTabs = (root = document) => {
    const tabGroups = Array.from(root.querySelectorAll('[data-tabs]'))

    tabGroups.forEach((tabGroup) => {
        if (tabGroup.dataset.tabsInitialized === 'true') return

        const { buttons, panels } = getTabParts(tabGroup)

        if (!buttons.length || buttons.length !== panels.length) return

        tabGroup.dataset.tabsInitialized = 'true'

        const initialIndex = buttons.findIndex((button) =>
            button.classList.contains(ACTIVE_CLASS)
        )
        let selectedIndex = initialIndex >= 0 ? initialIndex : 0

        buttons.forEach((button, index) => {
            button.addEventListener('click', () => {
                selectedIndex = index
                activateTab(tabGroup, index)
            })

            button.addEventListener('mouseenter', () => {
                activateTab(tabGroup, index)
            })

            button.addEventListener('mouseleave', () => {
                activateTab(tabGroup, selectedIndex)
            })

            button.addEventListener('keydown', (event) => {
                const nextIndex = getNextIndex(event, index, buttons.length)

                if (nextIndex !== null) {
                    event.preventDefault()
                    selectedIndex = nextIndex
                    activateTab(tabGroup, nextIndex, true)
                    return
                }

                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    selectedIndex = index
                    activateTab(tabGroup, index)
                }
            })
        })

        activateTab(tabGroup, selectedIndex)
    })
}
